import React from 'react';
import Image from 'next/image';
import styles from '../styles.module.scss';
import { ASSETS } from 'src/common/utils/config';
import CoveragePills from './CoveragePills';

const Index = ({ carousalItem }) => {
  return (
    <div className={styles.coverageInfoCardContainer}>
      <div className={styles.coverageInfoCardImage}>
        <Image src={carousalItem?.image_url} height={'250px'} width={'320px'} />
      </div>
      <div className={styles.coverageInfoCard}>
        <div className={styles.coverageInfoCardTitle}>
          {carousalItem?.title}
        </div>
        <div className={styles.coverages}>
          <CoveragePills list={carousalItem?.values} />
        </div>
        <div className={styles.coverageInfoNote}>
          <Image
            src={ASSETS.BLACK_INFO_ICON}
            height={'20px'}
            width={'20px'}
            style={{ minWidth: '20px' }}
          />
          <div className={styles.coverageInfoNoteText}>
            {carousalItem?.note_text}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
